<template>
  <b-card>
    <div class="flex justify-between">
      <div class="text-black text-[20px] mb-2 font-[600]">
        Dashboard Komchat <span v-if="currentTab === 'ai'">AI</span>
      </div>
      <div v-if="currentTab === 'ai'">
        <b-button
          id="btn-download-ai"
          variant="primary"
          size="sm"
          :disabled="isDownloadingAi"
        >
          <b-spinner
            v-if="isDownloadingAi"
            small
            class="mr-1"
          />
          <b-icon
            v-else
            icon="download"
          />
          Download
        </b-button>
        <DownloadMonthPopover
          target="btn-download-ai"
          @download="handleDownloadAI"
        />
      </div>
    </div>
    <div class="mb-2">
      <Tab
        v-model="currentTab"
      />
    </div>
    <div v-if="currentTab === 'ai'">
      <KomchatAi />
    </div>
    <div v-else-if="currentTab === 'dashboard'">
      <b-row>
        <b-col>
          <b-card
            no-body
            class="p-2 bg-[right_bottom] bg-no-repeat bg-contain bg-[url('https://storage.googleapis.com/komerce/assets/LP-Komchat/bg-komchat-coins.svg')]"
            style="border: 2px solid #FBBC05;"
          >
            <div class="flex justify-between">
              <div class="flex gap-2">
                <b-img
                  class="w-[20px] h-[20px]"
                  src="https://storage.googleapis.com/komerce/assets/komchat-coins.svg"
                /> Revenue
              </div>
              <FilterDropdown
                id="revenue"
                :options="optionsFilter"
                :value="filterRevenue"
                @change="handleFilterChange($event, 'revenue')"
                @date-change="handleDateFilterChange($event, 'revenue')"
              />
            </div>
            <div
              class="font-poppins text-[#626262] mb-2 font-semibold text-[34px] leading-[38px] tracking-[0] align-middle"
            >
              Rp{{ IDRWithoutLbl(animatedCard.revenue.now || 0) }} <span
                class="rounded-lg px-[4px] font-poppins font-normal text-[12px] leading-[20px] tracking-[0] align-middle"
                :class="dataCard.revenue.percentage.includes('-') ? 'bg-[#E31A1A] text-white' : 'bg-[#BEFCDE] text-[#34A770]'"
              >{{
                dataCard.revenue.percentage || '0%' }}</span>
            </div>
            <div class="text-sm">
              Last month revenue : <span class="font-bold text-[#626262]">Rp{{
                IDRWithoutLbl(animatedCard.revenue.last_month || 0) }}</span>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <SubscriptionCard
          :animated-card="animatedCard"
          :data-card="dataCard"
          :filter-subscription="filterSubscription"
          :options-filter="optionsFilter"
          @change="handleFilterChange($event.value, $event.type)"
          @date-change="handleDateFilterChange($event.dateRange, $event.type)"
        />
        <ClosingOrderCard
          :animated-card="animatedCard"
          :data-card="dataCard"
          :filter-closing-order="filterClosingOrder"
          :options-filter="optionsFilter"
          @change="handleFilterChange($event.value, $event.type)"
          @date-change="handleDateFilterChange($event.dateRange, $event.type)"
        />
        <BroadcastCard
          :animated-card="animatedCard"
          :data-card="dataCard"
          :filter-broadcast="filterBroadcast"
          :options-filter="optionsFilter"
          @change="handleFilterChange($event.value, $event.type)"
          @date-change="handleDateFilterChange($event.dateRange, $event.type)"
        />
      </b-row>
      <!-- <b-row>
        <UserRegisteredCard
          :animated-card="animatedCard"
          :filter-registered="filterRegistered"
          :options-filter="optionsFilter"
          @change="handleFilterChange($event.value, $event.type)"
          @date-change="handleDateFilterChange($event.dateRange, $event.type)"
        />
        <UserVerifiedCard
          :animated-card="animatedCard"
          :filter-verified="filterVerified"
          :options-filter="optionsFilter"
          @change="handleFilterChange($event.value, $event.type)"
          @date-change="handleDateFilterChange($event.dateRange, $event.type)"
        />
      </b-row> -->
      <div>
        <CardRevenue />
      </div>
    </div>
  </b-card>
</template>
<script>
import { IDRWithoutLbl } from '@/libs/currency'
import { firstDateOfMonth, lastDateOfMonth } from '@/store/helpers'
import { YEAR_MONTH_DAY } from '@/libs/filterDate'
import { optionsFilter } from './config'
import FilterDropdown from './components/FilterDropdown.vue'
import DownloadMonthPopover from './components/DownloadMonthPopover.vue'
import CardRevenue from './components/CardRevenue.vue'
import {
  apiDahsboardKomchat, apiRegisteredGrowthKomchat, apiVerifiedGrowthKomchat, apiRevenueGrowthKomchat,
  apiClosingOrderKomchat,
  apiBroadcastKomchat,
  apiExportAiKomchat,
} from './services/api.komchat.service'
import SubscriptionCard from './components/SubscriptionCard.vue'
import ClosingOrderCard from './components/ClosingOrderCard.vue'
import BroadcastCard from './components/BroadcastCard.vue'
// import UserVerifiedCard from './components/UserVerifiedCard.vue'
// import UserRegisteredCard from './components/UserRegisteredCard.vue'
import Tab from './dashboard/Tab.vue'
import KomchatAi from './dashboard/KomchatAi.vue'

export default {
  components: {
    KomchatAi,
    Tab,
    FilterDropdown,
    CardRevenue,
    SubscriptionCard,
    ClosingOrderCard,
    BroadcastCard,
    // UserVerifiedCard,
    // UserRegisteredCard,
    DownloadMonthPopover,
  },
  data() {
    return {
      startDate: firstDateOfMonth,
      endDate: lastDateOfMonth,
      dataCard: {
        revenue: {
          now: 0,
          last_mont: 0,
          percentage: '0%',
        },
        registered: {
          total: 0,
          today: 0,
          yesterday: 0,
        },
        verified: {
          total: 0,
          today: 0,
          yesterday: 0,
        },
        subscription: {
          total: 0,
          now: 0,
          percentage: '0%',
        },
        closingOrder: {
          total: 0,
          now: 0,
          percentage: '0%',
        },
        broadcast: {
          total: 0,
          now: 0,
          percentage: '0%',
        },
      },
      // Animated counter values
      animatedCard: {
        revenue: {
          now: 0,
          last_month: 0,
        },
        registered: {
          total: 0,
          today: 0,
          yesterday: 0,
        },
        verified: {
          total: 0,
          today: 0,
          yesterday: 0,
        },
        subscription: {
          total: 0,
          revenue: 0,
        },
        closingOrder: {
          total: 0,
          revenue: 0,
        },
        broadcast: {
          total: 0,
          revenue: 0,
        },
      },
      search: '',
      itemsTable: [],
      optionsFilter,
      limit: 15,
      offset: 0,
      filterRevenue: 'Bulan ini',
      filterRegistered: 'Bulan ini',
      filterVerified: 'Bulan ini',
      filterSubscription: 'Bulan ini',
      filterClosingOrder: 'Bulan ini',
      filterBroadcast: 'Bulan ini',
      lastData: false,
      isLoading: false,
      IDRWithoutLbl,
      filter: {
        status: [],
        typeProduct: [], // Changed to match TablePartner.vue's filter structure
      },
      currentTab: 'dashboard',
      isDownloadingAi: false,
    }
  },
  async mounted() {
    await this.getDataDashboard()
    await this.getRegisteredGrowthCard()
    await this.getVerifiedGrowthCard()
    await this.getRevenueGrowthCard()
    await this.getBroadcast()
    await this.getClosingOrder()

    await this.getRevenueMetrics()
  },
  methods: {
    animateValue(obj, key, subKey, start, end, duration = 1000) {
      const startTimestamp = Date.now()
      const step = () => {
        const now = Date.now()
        const progress = Math.min((now - startTimestamp) / duration, 1)
        const easeOutQuart = 1 - (1 - progress) ** 4
        const current = Math.floor(start + (end - start) * easeOutQuart)

        if (subKey) {
          this.$set(obj[key], subKey, current)
        } else {
          this.$set(obj, key, current)
        }

        if (progress < 1) {
          requestAnimationFrame(step)
        } else if (subKey) {
          this.$set(obj[key], subKey, end)
        } else {
          this.$set(obj, key, end)
        }
      }
      requestAnimationFrame(step)
    },
    async handleDownloadAI(data) {
      try {
        this.isDownloadingAi = true
        const startDateObj = new Date(data.year, data.month, 1)
        const endDateObj = new Date(data.year, data.month + 1, 0)
        const formattedStartDate = YEAR_MONTH_DAY(startDateObj)
        const formattedEndDate = YEAR_MONTH_DAY(endDateObj)

        const res = await apiExportAiKomchat({ start_date: formattedStartDate, end_date: formattedEndDate })
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `data-ai-komchat-${formattedStartDate}-to-${formattedEndDate}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (err) {
        this.$toast_error({ message: 'Gagal unduh laporan AI', err })
      } finally {
        this.isDownloadingAi = false
      }
    },
    handleFilterChange(value, type) {
      this.startDate = value.startDate
      this.endDate = value.endDate

      if (type === 'revenue') {
        this.getRevenueMetrics()
      } else if (type === 'subscription') {
        this.getRevenueGrowthCard()
      } else if (type === 'registered') {
        this.getRegisteredGrowthCard()
      } else if (type === 'verified') {
        this.getVerifiedGrowthCard()
      } else if (type === 'closingOrder') {
        this.getClosingOrder()
      } else if (type === 'broadcast') {
        this.getBroadcast()
      }
    },
    handleDateFilterChange(dateRange, type) {
      this.startDate = dateRange.startDate
      this.endDate = dateRange.endDate

      if (type === 'revenue') {
        this.getRevenueMetrics()
      } else if (type === 'subscription') {
        this.getRevenueGrowthCard()
      } else if (type === 'registered') {
        this.getRegisteredGrowthCard()
      } else if (type === 'verified') {
        this.getVerifiedGrowthCard()
      } else if (type === 'closingOrder') {
        this.getClosingOrder()
      } else if (type === 'broadcast') {
        this.getBroadcast()
      }
    },
    handleTableFilter(filters) {
      this.filter = filters
      this.itemsTable = []
      this.offset = 0
      this.lastData = false
      this.getDataDashboard()
    },
    handleSearchPartner: _.debounce(function searchData(value) {
      this.search = value
      this.lastData = false
      this.offset = 0
      this.itemsTable = []
      this.getDataDashboard()
    }, 1000),
    async getDataDashboard() {
      try {
        if (this.isLoading || this.lastData) return
        this.isLoading = true

        const { data } = await apiDahsboardKomchat({
          search: this.search,
          limit: this.limit,
          offset: this.offset + (this.itemsTable.length || 0),
          status: this.filter.status.join(','),
          productType: this.filter.typeProduct.join(','), // Updated to match new filter structure
        })

        // If no data returned at all, we've reached the end
        if (!data.data || data.data.length === 0) {
          this.lastData = true
          this.isLoading = false
          return
        }

        this.itemsTable = [...this.itemsTable, ...data.data]
        // this.offset += this.limit

        // Check if this is the last page (either by length or total count if available)
        if (data.total) {
          // If API provides total count
          this.lastData = this.itemsTable.length >= data.total
        } else {
          // If no total count, check if we received fewer items than requested
          this.lastData = data.data.length < this.limit
        }

        this.isLoading = false
      } catch (err) {
        this.$toast_error({ message: 'Gagal ambil data dashboard', err })
        this.isLoading = false
      }
    },
    async getRevenueMetrics() {
      const params = { start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) }
      try {
        const [revenueRes, closingOrderRes, broadcastRes] = await Promise.all([
          apiRevenueGrowthKomchat(params),
          apiClosingOrderKomchat(params),
          apiBroadcastKomchat(params),
        ])

        const revenueNow = revenueRes.data?.data?.now || 0
        const closingOrderNow = closingOrderRes.data?.data?.now || 0
        const broadcastNow = broadcastRes.data?.data?.now || 0
        const accumulatedNow = revenueNow + closingOrderNow + broadcastNow
        const accumulateLastMonth = (revenueRes.data?.data?.last_month || 0) + (closingOrderRes.data?.data?.last_month || 0) + (broadcastRes.data?.data?.last_month || 0)

        this.animateValue(this.animatedCard.revenue, 'now', null, 0, accumulatedNow || 0, 1500)
        this.animateValue(this.animatedCard.revenue, 'last_month', null, 0, accumulateLastMonth || 0, 1500)
        if (accumulateLastMonth > 0) {
          const pct = (((accumulatedNow - accumulateLastMonth) / accumulateLastMonth) * 100).toFixed(2)
          const sign = pct >= 0 ? '+' : ''
          this.dataCard.revenue.percentage = `${sign}${pct}%`
        } else {
          this.dataCard.revenue.percentage = '0%'
        }

        return {
          revenueData: revenueRes.data?.data,
          closingOrderData: closingOrderRes.data?.data,
          broadcastData: broadcastRes.data?.data,
          accumulatedNow,
        }
      } catch {
        this.$toast_error({ message: 'Gagal ambil data revenue metrics' })
        return null
      }
    },
    async getRevenueGrowthCard() {
      try {
        const { data } = await apiRevenueGrowthKomchat({ start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) })
        this.dataCard.subscription = data?.data

        this.animateValue(this.animatedCard.subscription, 'now', null, 0, data?.data?.now || 0, 1500)
        this.animateValue(this.animatedCard.subscription, 'total', null, 0, data?.data?.total || 0, 1500)
      } catch {
        this.$toast_error({ message: 'Gagal ambil data dashboard' })
      }
    },
    async getRegisteredGrowthCard() {
      try {
        const { data } = await apiRegisteredGrowthKomchat({ start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) })
        this.dataCard.registered = data?.data

        // Animate registered values
        this.animateValue(this.animatedCard.registered, 'total', null, 0, data?.data?.total || 0, 1500)
        this.animateValue(this.animatedCard.registered, 'today', null, 0, data?.data?.today || 0, 1500)
        this.animateValue(this.animatedCard.registered, 'yesterday', null, 0, data?.data?.yesterday || 0, 1500)
      } catch {
        this.$toast_error({ message: 'Gagal ambil data growth user' })
      }
    },
    async getVerifiedGrowthCard() {
      try {
        const { data } = await apiVerifiedGrowthKomchat({ start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) })
        this.dataCard.verified = data?.data

        // Animate verified values
        this.animateValue(this.animatedCard.verified, 'total', null, 0, data?.data?.total || 0, 1500)
        this.animateValue(this.animatedCard.verified, 'today', null, 0, data?.data?.today || 0, 1500)
        this.animateValue(this.animatedCard.verified, 'yesterday', null, 0, data?.data?.yesterday || 0, 1500)
      } catch {
        this.$toast_error({ message: 'Gagal ambil data verified user' })
      }
    },
    async getClosingOrder() {
      try {
        const { data } = await apiClosingOrderKomchat({ start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) })
        this.dataCard.closingOrder = data?.data

        // Animate closing order values
        this.animateValue(this.animatedCard.closingOrder, 'revenue', null, 0, data?.data?.now || 0, 1500)
        this.animateValue(this.animatedCard.closingOrder, 'total', null, 0, data?.data?.total || 0, 1500)
      } catch {
        this.$toast_error({ message: 'Gagal ambil data revenue closing order' })
      }
    },
    async getBroadcast() {
      try {
        const { data } = await apiBroadcastKomchat({ start_date: YEAR_MONTH_DAY(this.startDate), end_date: YEAR_MONTH_DAY(this.endDate) })
        this.dataCard.broadcast = data?.data

        this.animateValue(this.animatedCard.broadcast, 'revenue', null, 0, data?.data?.now || 0, 1500)
        this.animateValue(this.animatedCard.broadcast, 'total', null, 0, data?.data?.total || 0, 1500)
      } catch {
        this.$toast_error({ message: 'Gagal ambil data revenue broadcast' })
      }
    },
  },
}
</script>
